import { Select } from "antd"
import { useEffect, useState } from 'react';
import { SizeType } from "antd/es/config-provider/SizeContext";
import { getKnowledgeArea } from "../../../../controllers/entities";

interface Props  {
    onChange: (value : string) => void,
    onClear: () => void,
    mode? : any,
    size? : SizeType,
    defaultValue? : string,
    style? : any
}

const SelectKnowledgeArea = (props: Props) => {
    const [knowledgeAre, setknowledgeAre] = useState([]);
    useEffect(() => {
        const get_knowledgeArea = async () => {
            const knowledgeAreaData = await getKnowledgeArea();
            setknowledgeAre(knowledgeAreaData.map((knowledgeAreaData: any) => {
                return {
                    value: knowledgeAreaData.id,
                    label: knowledgeAreaData.AREA_DE_CONOCIMIENTO,
                }
            }));
        }
        get_knowledgeArea();
    }, []);
    
    return (
        <div style={{width : '100%'}}>
            <Select
                {...props}
                labelInValue
                allowClear
                size={props.size}
                defaultValue={props?.defaultValue}
                style={props.style}
                onChange={(value:any) => {
                    props.onChange(value);
                }}
                onClear={() => {
                    props.onClear();
                }}
                options={knowledgeAre}
            />        
        </div>
    );
}

export default SelectKnowledgeArea